import { render, staticRenderFns } from "./EditAboutUs.vue?vue&type=template&id=376d04fe&scoped=true&"
import script from "./EditAboutUs.vue?vue&type=script&lang=js&"
export * from "./EditAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376d04fe",
  null
  
)

export default component.exports